import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  FetchJustificationTypesActions as Actions,
  FetchJustificationTypesRequestAction as RequestAction,
} from 'store/ducks/justificationTypes';

export function* fetchJustificationTypesRequest(action: any) {
  const { onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.get, `type-justifications`);

    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
